<h2 mat-dialog-title>
    @if (data?.id) {
    {{ 'feedback_edit_title_existing' | transloco }}
    } @else {
    {{ 'feedback_edit_title_new' | transloco }}
    }
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="dialog-content">
    <form
        [formGroup]="formGroup"
        class="feedback-form"
    >

        @if (!data?.id) {
        <mat-form-field
            appearance="outline"
            class="subject-select-field"
        >
            <mat-label>{{ 'subject' | transloco }}</mat-label>
            <mat-select formControlName="subjectId">
                @for (subject of freeSubjects; track subject.id) {
                <mat-option [value]="subject.treeId">
                    {{ subject.name }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field> }

        <mat-tab-group
            id="tab-group"
            [dynamicHeight]="false"
            preserveContent
        >
            <mat-tab [label]="'feedback_edit_main_tab' | transloco">
                <div class="feedback-tab-shell">
                    <mat-tab-group
                        id="feedback-subtab-group"
                        [dynamicHeight]="false"
                        preserveContent
                    >
                        <mat-tab [label]="'feedback_edit_first_try_tab' | transloco">
                            <div class="feedback-scroll-area">
                                @if (firstTryEntries.length === 0) {
                                <p class="empty-state">
                                    {{ 'feedback_edit_no_first_try_messages' | transloco }}
                                </p>
                                } @else {
                                <div class="rs-range-container">
                                    @for (entry of firstTryEntries; track entry; let i = $index; let last = $last) {
                                    <div
                                        class="rs-range-tile"
                                        [class.empty-tile]="isRangeEmpty(entry)"
                                    >
                                        <div class="rs-range-header">
                                            <div class="rs-range-meta">
                                                @if (entry.from === entry.to) {
                                                <span>{{ entry.from }}%</span>
                                                } @else {
                                                <button
                                                    type="button"
                                                    class="clickable-percent-btn"
                                                    (click)="splitRange(firstTryEntries, i, false)"
                                                >
                                                    {{ entry.from }}%
                                                </button>
                                                <span class="range-separator">{{ 'till' | transloco
                                                    }}</span>
                                                <button
                                                    type="button"
                                                    class="clickable-percent-btn"
                                                    (click)="splitRange(firstTryEntries, i, true)"
                                                >
                                                    {{ entry.to }}%
                                                </button>
                                                }
                                            </div>

                                            <div class="rs-range-actions">
                                                @if (!last) {
                                                <button
                                                    mat-icon-button
                                                    class="scale-btn"
                                                    type="button"
                                                    (click)="adjustScale(firstTryEntries, i, 1)"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                }
                                                @if (firstTryEntries.length > 1) {
                                                <button
                                                    mat-icon-button
                                                    class="scale-btn"
                                                    type="button"
                                                    (click)="adjustScale(firstTryEntries, i, -1)"
                                                >
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                                }
                                                @if (firstTryEntries.length > 1) {
                                                <button
                                                    mat-icon-button
                                                    color="warn"
                                                    class="delete-tile-btn"
                                                    type="button"
                                                    (click)="deleteRange(firstTryEntries, i)"
                                                >
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                                }
                                            </div>
                                        </div>

                                        <div class="tile-messages-section">
                                            <div class="tile-message-input-row">
                                                <mat-form-field
                                                    appearance="outline"
                                                    subscriptSizing="dynamic"
                                                    class="tile-message-form-field"
                                                >
                                                    <mat-label>{{ 'feedback_edit_message_placeholder' | transloco
                                                        }}</mat-label>
                                                    <input
                                                        matInput
                                                        [(ngModel)]="tileDrafts[getTileKey('firstTry', i)]"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (keydown.enter)="addTileMessage(firstTryEntries, i, 'firstTry'); $event.preventDefault()"
                                                    />
                                                </mat-form-field>
                                                <button
                                                    mat-icon-button
                                                    color="primary"
                                                    type="button"
                                                    class="tile-message-add-icon-btn"
                                                    (click)="addTileMessage(firstTryEntries, i, 'firstTry')"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>

                                            <div
                                                class="tile-messages-list"
                                                cdkDropList
                                                [cdkDropListConnectedTo]="firstTryDropListIds"
                                                (cdkDropListDropped)="dropMessageAcrossRanges($event, entry)"
                                                [id]="'firstTry-' + i"
                                                [cdkDropListData]="entry.message"
                                            >
                                                @if (firstTryEntries.length > 1 && entry.message.length === 0) {
                                                <div class="tile-messages-empty-row">
                                                    <div class="tile-messages-empty-dropzone">
                                                        {{ 'feedback_edit_drop_message_here' | transloco }}
                                                    </div>
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        class="tile-message-placeholder-btn"
                                                        aria-hidden="true"
                                                        tabindex="-1"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                }
                                                @for (msg of entry.message; track trackByMessage($index, msg); let
                                                msgIdx = $index) {
                                                <div
                                                    class="tile-message-item"
                                                    cdkDrag
                                                >
                                                    <mat-form-field
                                                        appearance="outline"
                                                        subscriptSizing="dynamic"
                                                        class="tile-message-form-field"
                                                    >
                                                        <input
                                                            matInput
                                                            [(ngModel)]="entry.message[msgIdx]"
                                                            [ngModelOptions]="{standalone: true}"
                                                        />
                                                    </mat-form-field>
                                                    <button
                                                        mat-icon-button
                                                        color="warn"
                                                        type="button"
                                                        (click)="removeTileMessage(firstTryEntries, i, msgIdx)"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </mat-tab>

                        <mat-tab [label]="'feedback_edit_second_try_tab' | transloco">
                            <div class="feedback-scroll-area">
                                @if (secondTryEntries.length === 0) {
                                <p class="empty-state">
                                    {{ 'feedback_edit_no_second_try_messages' | transloco }}
                                </p>
                                } @else {
                                <div class="rs-range-container">
                                    @for (entry of secondTryEntries; track entry; let i = $index; let last = $last) {
                                    <div
                                        class="rs-range-tile"
                                        [class.empty-tile]="isRangeEmpty(entry)"
                                    >
                                        <div class="rs-range-header">
                                            <div class="rs-range-meta">
                                                @if (entry.from === entry.to) {
                                                <span>{{ entry.from }}%</span>
                                                } @else {
                                                <button
                                                    type="button"
                                                    class="clickable-percent-btn"
                                                    (click)="splitRange(secondTryEntries, i, false)"
                                                >
                                                    {{ entry.from }}%
                                                </button>
                                                <span class="range-separator">{{ 'till' | transloco
                                                    }}</span>
                                                <button
                                                    type="button"
                                                    class="clickable-percent-btn"
                                                    (click)="splitRange(secondTryEntries, i, true)"
                                                >
                                                    {{ entry.to }}%
                                                </button>
                                                }
                                            </div>

                                            <div class="rs-range-actions">
                                                @if (!last) {
                                                <button
                                                    mat-icon-button
                                                    class="scale-btn"
                                                    type="button"
                                                    (click)="adjustScale(secondTryEntries, i, 1)"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                                }
                                                @if (secondTryEntries.length > 1) {
                                                <button
                                                    mat-icon-button
                                                    class="scale-btn"
                                                    type="button"
                                                    (click)="adjustScale(secondTryEntries, i, -1)"
                                                >
                                                    <mat-icon>remove</mat-icon>
                                                </button>
                                                }
                                                @if (secondTryEntries.length > 1) {
                                                <button
                                                    mat-icon-button
                                                    color="warn"
                                                    class="delete-tile-btn"
                                                    type="button"
                                                    (click)="deleteRange(secondTryEntries, i)"
                                                >
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                                }
                                            </div>
                                        </div>

                                        <div class="tile-messages-section">
                                            <div class="tile-message-input-row">
                                                <mat-form-field
                                                    appearance="outline"
                                                    subscriptSizing="dynamic"
                                                    class="tile-message-form-field"
                                                >
                                                    <mat-label>{{ 'feedback_edit_message_placeholder' | transloco
                                                        }}</mat-label>
                                                    <input
                                                        matInput
                                                        [(ngModel)]="tileDrafts[getTileKey('secondTry', i)]"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (keydown.enter)="addTileMessage(secondTryEntries, i, 'secondTry'); $event.preventDefault()"
                                                    />
                                                </mat-form-field>
                                                <button
                                                    mat-icon-button
                                                    color="primary"
                                                    type="button"
                                                    class="tile-message-add-icon-btn"
                                                    (click)="addTileMessage(secondTryEntries, i, 'secondTry')"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>

                                            <div
                                                class="tile-messages-list"
                                                cdkDropList
                                                [cdkDropListConnectedTo]="secondTryDropListIds"
                                                (cdkDropListDropped)="dropMessageAcrossRanges($event, entry)"
                                                [id]="'secondTry-' + i"
                                                [cdkDropListData]="entry.message"
                                            >
                                                @if (secondTryEntries.length > 1 && entry.message.length === 0) {
                                                <div class="tile-messages-empty-row">
                                                    <div class="tile-messages-empty-dropzone">
                                                        {{ 'feedback_edit_drop_message_here' | transloco }}
                                                    </div>
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        class="tile-message-placeholder-btn"
                                                        aria-hidden="true"
                                                        tabindex="-1"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                }
                                                @for (msg of entry.message; track trackByMessage($index, msg); let
                                                msgIdx = $index) {
                                                <div
                                                    class="tile-message-item"
                                                    cdkDrag
                                                >
                                                    <mat-form-field
                                                        appearance="outline"
                                                        subscriptSizing="dynamic"
                                                        class="tile-message-form-field"
                                                    >
                                                        <input
                                                            matInput
                                                            [(ngModel)]="entry.message[msgIdx]"
                                                            [ngModelOptions]="{standalone: true}"
                                                        />
                                                    </mat-form-field>
                                                    <button
                                                        mat-icon-button
                                                        color="warn"
                                                        type="button"
                                                        (click)="removeTileMessage(secondTryEntries, i, msgIdx)"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                        </mat-tab>

                        <mat-tab [label]="'feedback_edit_motivating_tab' | transloco">
                            <div class="feedback-scroll-area">
                                <div class="rs-range-container">
                                    <div class="rs-range-tile">
                                        <div class="tile-messages-section">
                                            <div
                                                class="tile-message-input-row"
                                                formGroupName="motivatingDraft"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                    subscriptSizing="dynamic"
                                                    class="tile-message-form-field"
                                                >
                                                    <mat-label>{{ 'feedback_edit_motivating_new_label' | transloco
                                                        }}</mat-label>
                                                    <input
                                                        matInput
                                                        formControlName="text"
                                                        (keydown.enter)="addMotivatingText(); $event.preventDefault()"
                                                    />
                                                </mat-form-field>
                                                <button
                                                    mat-icon-button
                                                    color="primary"
                                                    type="button"
                                                    class="tile-message-add-icon-btn"
                                                    (click)="addMotivatingText()"
                                                >
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>

                                            <div
                                                class="tile-messages-list"
                                                formArrayName="motivating"
                                            >
                                                @for (control of motivatingArray.controls; track control; let i =
                                                $index) {
                                                <div
                                                    class="tile-message-item"
                                                    [formGroupName]="i"
                                                >
                                                    <mat-form-field
                                                        appearance="outline"
                                                        subscriptSizing="dynamic"
                                                        class="tile-message-form-field"
                                                    >
                                                        <input
                                                            matInput
                                                            formControlName="text"
                                                        />
                                                    </mat-form-field>
                                                    <button
                                                        mat-icon-button
                                                        color="warn"
                                                        type="button"
                                                        (click)="removeMotivatingText(i)"
                                                        [attr.aria-label]="'feedback_edit_delete_motivating_aria' | transloco"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-tab>

            <mat-tab [label]="'feedback_edit_nlp_tab' | transloco">
                <div class="feedback-form tab-placeholder">
                    <p>{{ 'feedback_edit_nlp_placeholder' | transloco }}</p>
                </div>
            </mat-tab>
        </mat-tab-group>
    </form>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-button
        type="button"
        (click)="onCancel()"
    >{{ 'abort' | transloco }}</button>
    <button
        mat-raised-button
        type="button"
        (click)="onSave()"
        [disabled]="!data?.id && !formGroup.get('subjectId')?.value"
    >{{ 'save' | transloco }}</button>
</mat-dialog-actions>